export async function newsletterSubscribe(bridgeUrl: string, locale: string, emailAddress: string, recaptchaToken: string, origin?: string, endpointPath?: string) {
  const init = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: JSON.stringify({ email: emailAddress, origin, recaptchaToken }),
  }

  const url = `${bridgeUrl}/newsletter/${locale}/subscribe${endpointPath ? `?endpoint_path=${encodeURIComponent(endpointPath)}` : ''}`
  const response = await fetch(url, init)
  const result = await response.json()

  const success = result.success

  if (success) {
    window.dataLayer?.push({
      event: 'newsletter_subscription',
      newsletter_origin: origin,
      newsletter_email: emailAddress,
    })
  }
  return success || false
}
